const enTrans = {
   "?Français": "French",
   "?Anglais": "English",
   "?turn_landscape": "Please turn your device in \"Landscape\" mode.",
   "?Veuillez vous identifier": "Please log in",
   "?Serveur": "Server",
   "?Projet": "Project",
   "?Identifiant": "Identifier",
   "?Mot de passe": "Password",
   "?Votre mot de passe": "Your password",
   "?Se souvenir de moi": "Remember me",
   "?Mot de passe oublié": "Lost password",
   "?S'identifier": "Log in",
   "?Gamme": "Range|Ranges",
   "?Par gamme": "By range",
   "?Collection": "Collection|Collections",
   "?Sous-collection": "Sub-collection|Sub-collections",
   "?Par collection": "By collection",
   "?Famille": "Family|Families",
   "?Par famille": "By family",
   "?Porté": "Style|Styles",
   "?Par porté": "By style",
   "?Typologie": "Typology|Typologies",
   "?Couleur": "Color|Colors",
   "?Univers": "Universe|Universes",
   "?Cycle": "Cycle|Cycles",
   "?Param comm": "Business param",
   "?Taille": "Size",
   "?Quantité": "Quantity",
   "?Dashboard": "Dashboard",
   "?Accueil": "Home",
   "?Catalogue": "Catalog",
   "?Client": "Customer|Customers",
   "?Paramètres": "Preferences",
   "?Langue": "Language",
   "?Tarif": "Tariff|Tariffs",
   "?Autre": "Other|Others",
   "?Commandes en cours": "Orders in progress",
   "?Nouvelle commande": "New order",
   "?Retour au catalogue": "Back to catalog",
   "?Prix": "Price",
   "?Poids": "Weight",
   "?Poids diamants": "Diamonds weight",
   "?Diamants": "Diamonds",
   "?Ecrin": "Box|Boxes",
   "?Bijou": "Jewel|Jewels",
   "?À partir de": "Starting from",
   "?QTÉ": "QTY",
   "?Qté": "Qty",
   "?Longueur": "Length",
   "?Largeur": "Width",
   "?Hauteur": "Height",
   "?Poids brut": "Gross weight",
   "?Poids net": "Net weight",
   "?Par combien": "BHM",
   "?pds_g": "g",
   "?pds_kg": "kg",
   "?pds_ct": "ct",
   "?len_m": "m",
   "?len_cm": "cm",
   "?Sélecteur de quantité": "Quantity picker",
   "?Vérifier disponibilité": "Check availability",
   // "EUR": "€,R",     // Placer à droite
   // "USD": "US$,L",     // Placer à gauche
   // "HKD": "HK$,L",   // Placer à gauche
   // "SGD": "SG$,L",   // Placer à gauche
   // "AUD": "AU$,L",   // Placer à gauche
   // "JPY": "¥,L",     // Placer à gauche
   // "WON": "₩,L",     // Placer à gauche
   // "CAD": "CA$,L",   // Placer à gauche
   // "CNY": "CNY,L",   // Placer à gauche
   // "DKK": "DKK,L",   // Placer à gauche
   // "CHF": "CHF,L",   // Placer à gauche
   // "MOP": "MOP,L",   // Placer à gauche
   // "MAD": "MAD,L",   // Placer à gauche
   // "NOK": "NOK,L",   // Placer à gauche
   // "SEK": "SEK,L",   // Placer à gauche
   // "GBP": "£,L",     // Placer à gauche
   "?Saisie multiple": "Multiple entries",
   "?Disponible": "Available",
   "?Indisponible": "Unavailable",
   "?Pas de stock": "Out of stock",
   "?Non communiqué": "?Undisclosed",
   "?Ajouter à la commande": "Add to order",
   "?Ajouter aux quotas": "Add to quotas",
   "?Modifier la commande": "Modify order",
   "?Modifier les quotas": "Modify quotas",
   "?Aucune commande sélectionnée": "No selected order",
   "?Aucun client sélectionné": "No selected customer",
   "?Annuler": "Cancel",
   "?Non": "No",
   "?OK": "OK",
   "?Oui": "Yes",
   "?Purger le cache": "Clear cache",
   "?Purger les tarifs": "Clear prices",
   "?x_sur_y": "of",
   "?Filtre": "Filter|Filters",
   "?Appliquer": "Apply",
   "?Se déconnecter": "Logout",
   "?NC": "NC",
   "?Gratuit": "Free",
   "?keypad_hint_physical_keyboard": "Tip: you can also type on your computer keyboard",
   "?Réinitialiser les préférences": "Reset preferences",
   "?Réinitialiser + nouvel udid": "Reset + new udid",
   "?warn_expert_mode": "WARNING, in Expert mode don't change anything without being asked to by the technical staff.",
   "?Repasser en mode Normal": "Switch back to Normal mode",
   "?Passer en mode Expert": "Switch to Expert mode",
   "?Format d'heure": "Time format",
   "?Format de date": "Date format",
   "?Priorité des images": "Images priority",
   "?by Messika": "by Messika",
   "?Interne": "Internal",
   "?DD-MM-YYYY": "DD-MM-YYYY",
   "?MM-DD-YYYY": "MM-DD-YYYY",
   "?YYYY-MM-DD": "YYYY-MM-DD",
   "?YYYY-DD-MM": "YYYY-DD-MM",
   "?min_length": "Min length before filtering",
   "?Fermeture popups": "Close popups",
   "?Borneur de prix": "Price slider",
   "?Bouton seulement": "Button only",
   "?Partout": "Anywhere",
   "?Gauche": "Left",
   "?Centré": "Middle",
   "?pas chargé": "not loaded",
   "?chargé": "loaded",
   "?list_length_per_page": "Lines per page on lists",
   "?Afficher ascenseurs": "Show scrollbars",
   "?Thème alternatif (test couleurs)": "Alternative theme (color test)",
   "?Afficher le toggle de thème global": "Show the global theme toggle",
   "?Paramètres régionaux": "Locales",
   "?Interface": "Interface",
   "?Période d'absence": "Absence period",
   "?du": "from",
   "?au": "to",
   "?inclus": "included",
   "?Les deux dates sont obligatoires et \"du\" doit être avant ou égal à \"au\".": "Both dates are required and \"from\" must be before or equal to \"to\".",
   "?Absence enregistrée : du": "Absence saved: from",
   "?Enregistrer": "Save",
   "?Effacer": "Clear",
   "?Position catalogue": "Catalog display",
   "?max_buttons_on_lists": "Max page buttons on lists",
   "?Quitter le client": "Leave customer",
   "?Quitter commande": "Leave order",
   "?Sélectionner": "Select",
   "?Envoyer en PDF à...": "Send as PDF to...",
   "?Dupliquer": "Duplicate",
   "?Synchroniser": "Synchronize",
   "?Sync": "Sync",
   "?Sync depuis": "Sync from",
   "?Dernière sync": "Last sync",
   "?Forcer une date...": "Force a date...",
   "?Forcer sync à partir de": "Force sync from",
   "?Signature client": "Customer signature",
   "?Toutes collections": "All collections",
   "?Toutes familles": "All families",
   "?Tous": "All",
   "?Toutes": "All",
   "?Supprimer": "Delete",
   "?Modifier": "Edit",
   "?N° Cde": "Order ID",
   "?N°": "ID",
   "?Nom client": "Customer name",
   "?Téléphone": "Phone",
   "?Email": "Email|Emails",
   "?Date": "Date",
   "?Prix total": "Total price",
   "?Total": "Total",
   "?Livraison": "Delivery",
   "?Action": "Action|Actions",
   "?Pièces": "Items",
   "?Modèle": "Model|Models",
   "?Commande": "Order|Orders",
   "?Commande ECR": "ECR Order",
   "?Commande ECF": "ECF Order",
   "?Commande Retail": "Retail Order",
   "?Libellé": "Label",
   "?Commentaire": "Comment",
   "?Commentaire ligne": "Line comment",
   "?Cess.": "Cess.",    // P. Cession
   "?Vider": "Clear",
   "?Trié par": "Sort by",
   "?Nom": "Name",
   "?Affichage de": "Display",
   "?Précédentes": "Previous",
   "?Suivantes": "Next",
   "?par page": "per page",
   "?Entre": "Between",
   "?et": "and",
   "?oui": "yes",
   "?non": "no",
   "?Retour": "Back",
   "?Voir les tarifs": "Show tariffs",
   "?Masquer les tarifs": "Hide tariffs",
   "?Adresse": "Address|Addresses",
   "?Adresse de livraison": "Delivery address|Delivery addresses",
   "?Voir": "See",
   "?Créer une commande": "Create order",
   "?Créer une ECR": "Create ECR order",
   "?Créer une ECF": "Create ECF order",
   "?Créer une commande Retail": "Create a Retail order",
   "?Créer un modèle": "Create a template",
   "?Ecrire un mail": "Write a mail",
   // "Voir les contacts": "Show contacts",
   // "Voir les adresses": "Show addresses",
   // "Voir les stats": "Show stats",
   "?Voir les infos": "Show infos",
   "?Afficher puce pour byMessika": "Show bullet for byMessika",
   "?Formater numéros de téléphone": "Format phone numbers",
   "?Code": "Code",
   "?Informations": "Informations",
   "?Stats": "Stats",
   "?Contact": "Contact|Contacts",
   "?N° de commande": "Order ID",
   "?Supprimer toutes les commandes": "Delete all orders",
   "?Suppression": "Deletion",
   "?confirmer_suppression_bdc": "Do you really want to delete this order?",
   "?confirmer_suppression_ligne": "Do you really want to delete this item from your order?",
   "?confirmer_synchronisation_bdc": "Do your really want to sync these orders ?",
   "?confirmer_soumission_bdc": "Do you really want to submit the selected Retail (ECR/ECF) orders for validation?",
   "?confirmer_soumission_retail": "Do you want to submit this Retail order\nfor validation?|Do you want to submit these Retail orders\nfor validation?",
   "?Synchronisation": "Synchronization",
   "?Valider": "Validate",
   "?Afficher les numéros de semaine (date picker)": "Show week numbers (date picker)",
   "?Quantité maxi par ligne de commande": "Max quantity per order line",
   "?Nouvelle commande %1 créée et activée": "New order %1 created and selected",
   "?article": "item|items",
   "?delay_show_cess": "Press delay to show cession prices (ms)",
   "?history_size": "History size (orders, customers...)",
   "?Garder historique ouvert": "Keep history open",
   "?reste x_sur_y cars": "Remaining %1 character over %2|Remaining %1 characters over %2",
   "?Contremarque": "Countermark",
   "?Implantation": "Implementation",
   "?Triangulaire": "Triangular",
   "?Vérifier disponibilité sur %1": "Check availability on %1",
   "?Disponible sur %1": "Available on %1",
   "?Indisponible sur %1": "Unavailable on %1",
   "?Non communiqué sur %1": "?Undisclosed on %1",
   "?Confié": "Consignment|Consignments",
   "?Devis": "Quotation",
   "?Paramétrer": "Setup",
   "?Ajout de ligne par SKU": "Add line from SKU",
   "?Chercher un SKU": "Search by SKU",
   "?Recherche dans le catalogue": "Search in catalog",
   "?Recherche dans cette commande": "Search in this order",
   "?item_X_added2order": "Item %1 added to order|%2 items %1 added to order",
   "?item_X_replaced_in_order": "Line %1 replaced — new quantity: %2",
   "?item_X_cumulated_in_order": "Line %1 cumulated — new quantity: %2",
   "?X_lignes_ajoutees": "%1 line added to order|%1 lines added to order",
   "?Quantité invalide": "Invalid quantity",
   "?Quantité invalide pour X": "Invalid quantity: %1",
   "?Erreurs ajout SKU": "Errors while adding",
   "?PCB": "BHM",
   "?Afficher le PCB": "Show BHM",
   "?SKU déjà présent": "SKU already present",
   "?sku_duplicate_info": "SKU %1 is already in the order (current quantity: %2).",
   "?sku_duplicate_question": "Replace with %1, or cumulate to %2?",
   "?Cumuler": "Cumulate",
   "?Remplacer": "Replace",
   "?SKU inconnu": "Unknown SKU %1: no matching model",
   "?SKU bijou dans commande retail": "SKU %1 is a jewelry item: it cannot be added to a retail order",
   "?SKU bijou dans quota retail": "SKU %1 is a jewelry item: it cannot be added to a retail quota",
   "?SKU bijou dans modele quota retail": "SKU %1 is a jewelry item: it cannot be added to a retail quota template",
   "?SKU retail dans commande bijou": "SKU %1 is a retail item: it cannot be added to a jewelry order",
   "?Aucun prix pour ce SKU": "No price found for SKU %1 in this region",
   "?SKU errone corrige": "SKU %1 was invalid and has been corrected to %2 — %3",
   "?Cet article n'a pas de taille": "This item has no size",
   "?Cet article n'a pas de couleur": "This item has no color",
   "?SKU rejete": "SKU %1 rejected — %2",
   "?Couleur manquante": "Missing color",
   "?Couleur inconnue": "Unknown color",
   "?Taille manquante": "Missing size",
   "?Taille inconnue": "Unknown size",
   "?Quota retail dépassé": "Quota exceeded for SKU %1: %2 unit(s) available",
   "?Quota retail non applicable": "No applicable quota for this customer at this period",
   "?Remise": "Discount",
   "?Remise ligne": "Line discount",
   "?Remise invalide (0-100)": "Invalid discount (enter a % between 0 and 100)",
   "?Type": "Type",
   "?max_tarifs_offline": "Max numbre of tariffs loadable for offline mode",
   "?Montrer l'état": "Show status",
   "?Seulement les tarifs cochés": "Only selected tariffs",
   "?nb_tarifs_sel_sur_x": "%1 tariff selected over %2|%1 tariffs selected over %2",
   "?dont_x_dispo_deco": "%1 available in offline mode (%2 max.)",
   "?Préchargé": "Preloaded",
   "?Mode déconnecté": "Offline mode",
   "?Région": "Region",
   "?Listé": "Listed",
   "?Chargé": "Loaded",
   "?Chargé si besoin": "Loaded if needed",
   "?Erreur de chargement": "Loading error",
   "?Non sélectionné": "Not selected",
   "?Préparation offline": "Prepare offline",
   "?Support": "Support",
   "?oMe_subject_support": "oMe - Support request",
   "?Appeler": "Call",
   "?Préparer le mode offline": "Prepare offline mode",
   "?Fermer": "Close",
   "?Terminé": "Finished",
   "?Envoyer": "Send",
   "?Importer": "Import",
   "?Envoi en cours": "Sending in progress",
   "?txt_sync_annulé": "Offline preparing canceled. Some images will be missing if you loose your Internet connection!",
   "?load_offline_assets": "Loading data for offline mode",
   "?Page d'assistance": "Support page",
   "?assist_wrong": "If you've reached this page by mistake:",
   "?assist_send_prefs": "If the IT staff requested it, send your technical data using this button:",
   "?assist_got_prefs": "An update of your technical data has been prepared by the IT staff. Do you want to import it?",
   "?impersonate_as": "Impersonation: log in as (email)",
   "?Continuer": "Continue",
   "?impersonate_warn_title": "Log in as another account",
   "?impersonate_warn_purge": "The whole local database will be erased (customers, orders, BI, consignments, RAL, image caches)",
   "?impersonate_warn_as": "to log in as",
   "?impersonate_warn_return": "Going back to your own account will also erase the whole local database.",
   "?impersonate_warn_unsynced": "Warning: %1 unsynchronized order(s) on this device will be lost.",
   "?impersonate_banner_login": "Logging in as",
   "?impersonate_banner_login_2a": "Enter",
   "?impersonate_banner_login_2b": "YOUR",
   "?impersonate_banner_login_2c": "login and",
   "?impersonate_banner_login_2d": "YOUR",
   "?impersonate_banner_login_2e": "password.",
   "?impersonation_refused": "Impersonation refused: check the account's impersonator permission and the target email",
   "?impersonation_refused_no_right": "Impersonation refused: account %1 does not have the impersonator permission",
   "?impersonation_refused_unexpected": "Impersonation refused: unexpected response (%1)",
   "?impersonation_refused_error": "Impersonation refused: %1",
   "?impersonation_forbidden_server": "Impersonation refused by the server: impersonator permission missing",
   "?impersonation_target_not_found_server": "Impersonation: target account not found on the server",
   "?impersonate_banner": "Logged in as %1 — operator: %2",
   "?impersonate_exit": "Leave impersonation",
   "?impersonate_exit_warn": "The whole local database will be erased.",
   "?impersonate_exit_warn_2": "You will then be able to log in normally.",
   "?impersonate_offline_refused": "Network required to resume impersonation",
   "?impersonate_back": "Back to my account",
   "?impersonate_back_title": "Back to my account",
   "?impersonate_back_warn": "The whole local database will be erased.",
   "?impersonate_back_warn_2": "You will have to log in again with your own account (full sync).",
   "?impersonate_title": "Impersonation",
   "?impersonate_refresh": "Refresh data",
   "?impersonate_refresh_progress": "Refreshing data…",
   "?impersonate_refresh_done": "Data up to date",
   "?impersonate_as_label": "Logged in as",
   "?impersonate_operator": "Operator",
   "?impersonate_toggle": "Show / hide details",
   "?Durée maxi d'inactivité": "Max inactive duration",
   "?Fin de session dans": "Session end in",
   "?Erreur de récupération des données": "Failed to fetch data",
   "?Erreur inconnue": "Unknown error",
   "?Accès refusé": "Login denied",
   "?clean_db": "If the IT staff requests it, clean:",
   "?Base de données": "Database",
   "?Commandes (Danger !)": "Orders (Danger!)",
   "?Images clés": "Key images",
   "?Images modèles": "Model images",
   "?Global": "Global",
   "?Quitter cette page": "Leave this page",
   "?Tarif à télécharger": "Tariff to download",
   "?Télécharger le tarif": "Download tariff",
   "?Téléchargement du tarif": "Downloading tariff",
   // "?Le tarif du client n'est pas dans votre liste !": "The tariff for this customer is not in your list!",
   "?Le tarif du client est inconnu !": "The tariff for this customer is unknown!",
   "?Voir dans le catalogue": "View in catalog",
   "?Forcer synchronisation": "Force syncing",
   "?Traitée": "Processed",
   "?En cours oMe": "In progress oMe",
   "?Prix public": "Public price",
   "?order_cloned": "You're now working on the duplicated order",
   "?Détail": "Detail|Details",
   "?Chercher un client": "Search a customer",
   "?Chercher un client (code, nom, ville, pays, clé)": "Search a customer (code, name, city, country, key)",
   "?Chercher une commande": "Search an order",
   "?Description": "Description",
   "?Adresse mail": "Mail address|Mail addresses",
   "?Message": "Message",
   "?Envoyer mail": "Send mail",
   "?Documentation": "Documentation",
   "?Mot de passe unique": "One time password",
   "?OTP_scan1": "Scan this QRCode or copy-paste the code in your OTP application. For safty reasons, do not keep it anywhere else.",
   "?OTP_scan2": "Then enter the 6-digit code generated by your OTP application:",
   "?Code OTP": "OTP code",
   "?6 chiffres": "6 digits",
   "?Envoyer le code": "Email me the code",
   "?Renvoyer": "Resend the code",
   "?Code reçu par email": "Code received by email",
   "?Nouveau mot de passe": "New password",
   "?Votre nouveau mot de passe": "Your new password",
   "?check_mailbox_for_pin": "Check your mailbox: the code to enter below has been emailed to you.",
   "?pwd_rule_length": "At least 10 characters",
   "?pwd_rule_lower": "One lowercase letter",
   "?pwd_rule_upper": "One uppercase letter",
   "?pwd_rule_digit": "One digit",
   "?pwd_rule_symbol": "One character that is neither a letter nor a digit (symbol, punctuation, accent…)",
   "?pwd_too_weak": "The new password does not meet the required rules.",
   "?pin_sent": "If an account exists for this identifier, a code has just been emailed.",
   "?Saisissez votre identifiant": "Please enter your identifier first.",
   "?Masquer": "Hide",
   "?Changer le mot de passe": "Set new password",
   "?resetpwd_ok": "Password changed",
   "?resetpwd_nok": "Impossible to change password!",
   "?Mauvais code": "Wrong code",
   "?Pièce": "Item|Items",
   "?Ventes": "Sales",
   "?Reste à livrer": "Remaining delivery",
   "?Limite crédit": "Credit limit",
   "?hist_commandes": "Fetching %1 order…|Fetching %1 orders…",
   "?Vérification des commandes": "Checking orders…",
   "?chiffre_affaires": "Business sales",
   "?Mois": "Month",
   "?À livrer": "Remaining",
   "?Vers": "To",
   "?Exclusivité boutique": "Store exclusive",
   "?Template": "Template|Templates",
   "?Prospect": "Prospect|Prospects",
   "?Bienvenue": "Welcome",
   "?Retail": "Retail",
   "?Retail interne": "ECR",
   "?Retail externe": "ECF",
   "?SKU": "SKU",
   "?Aucune ligne": "No line",
   "?Dimensions": "Dimensions",
   "?Commande incompatible": "Incompatible order",
   "?Sur commande/Devis": "Upon request",
   "?Mesures": "Measurements",
   "?mesures_lg_totale": "Total length of product (cm):",
   "?mesures_tour_cou": "Neck circumference (cm):",
   "?mesures_tour_poignet": "Wrist circumference (cm):",
   "?mesures_largeur": "Width of product (mm):",
   "?mesures_lg_chaine": "Chain length (cm):",
   "?mesures_nb_anneaux": "Nb of jump rings:",
   "?Pierres": "Stones",
   "?pierres_nb_certif_gia": "Nb of GIA certified stones:",
   "?pierres_nb_certif_sarines": "Nb of SARINE certified stones:",
   "?pierres_nb_certif_autres": "Nb of OTHER certified stones:",
   "?pierres_nb_centres": "Nb of center stones:",
   "?Si boucles d'oreilles": "If Earrings",
   "?Mono": "Mono",
   "?Paire": "Single",
   "?BEST SELLER": "BEST SELLER",
   "?WARNING": "WARNING",
   "?ICONIC": "ICONIC",
   "?SPO": "SPECIAL ORDER",
   "?SURCO": "IN ORDER ONLY",
   "?Quotas": "Quotas",
   "?Quota actuel": "Current quota",
   "?Quota dépassé": "Quota exceeded",
   "?Quota épuisé": "Quota exhausted",
   "?Hors quota": "Out of quota",
   "?Dépassement autorisé": "Overage allowed",
   "?Restant": "Remaining",
   "?Quota restant": "Remaining quota",
   "?(hors cette cde)": "(excl. this order)",
   "?Dépôt": "Depot",
   "?Collision": "Conflict",
   "?collision": "conflict|conflicts",
   "?Quota existant pour cette période — sera modifié selon les options ci-dessous": "Existing quota for this period — will be modified according to the options below",
   "?Synchroniser vers M3": "Final validation",
   "?Validation finale et envoi M3": "Final validation & send to M3",
   "?Soumettre au valideur final": "Submit to final approver",
   "?Soumettre la commande pour validation": "Submit order for validation",
   "?msg_validation_finale": "This is the final validation.\nThe order will be locked and synchronized to M3.",
   "?msg_soumettre_n1": "The order will be forwarded to the final approver.",
   "?msg_soumettre_validation": "The order will be forwarded to a validator. You won't be able to modify or see it during the validation workflow.",
   "?Cons.": "Used",
   "?Rest.": "Left",
   "?Valider vers N1": "Validate to N1",
   "?Validation finale": "Final validation",
   "?Renvoyer au client": "Send back to customer",
   "?msg_send_to_client": "Send this order to the customer?\nYou will lose control over it (it becomes a draft on the customer side).",
   "?msg_return_to_client": "Send this order back to the customer?\nYou will lose access to it (it returns to a draft on the customer side).",
   "?Envoyer au client": "Send to customer",
   "?Erreur lors de l'envoi au client": "Failed to send to customer",
   "?Reliquat de": "Remainder from",
   "?Envoi vers N2": "Send to N2",
   "?Garder reliquat": "Keep remainder",
   "?Confirmer la validation finale de cette commande ?": "Confirm the final validation of this order?",
   "?Reliquat détecté": "Remainder detected",
   "?order_stale": "This order has changed or is no longer accessible to you.",
   "?order_action_failed": "Action failed for now, please try again.",
   "?order_save_failed": "Failed to save the order (insufficient rights or network).",
   "?Quota": "Quota",
   "?Consommé": "Consumed",
   "?PU": "UP",
   "?Stock": "Stock",
   "?NEW": "NEW",
   "?Tout refuser": "Refuse all",
   "?Ajouter ligne": "Add line",
   "?Référence SKU": "SKU Reference",
   "?Annuler les modifications": "Cancel modifications",
   "?Quitter la validation": "Leave validation",
   "?Quitter validation": "Leave validation",
   "?Ouvrir validation...": "Open validation...",
   "?Toutes les modifications seront perdues.": "All modifications will be lost.",
   "?Annuler suppression": "Undo delete",
   "?Chargement": "Loading",
   "?acceptée": "accepted",
   "?refusée": "refused",
   "?ajoutée": "added",
   "?modifiée": "modified",
   "?supprimée": "deleted",
   "?inchangée": "unchanged",
   "?vs_demande_client": "(compared to the customer's original request)",
   "?aucune ligne conservée": "no line kept",
   "?ligne": "line|lines",
   "?Référence": "Reference",
   "?Intitulé": "Description",
   "?Init.": "Init.",
   "?Final": "Final",
   "?Reliq.": "Rem.",
   "?Exporter CSV": "Export CSV",
   "?Exporter Excel": "Export Excel",
   "?Importer CSV/Excel": "Import CSV/Excel",
   "?Importer quota": "Import quotas",
   "?Créer...": "Create...",
   "?Quota Retail": "Retail Quotas",
   "?Créer des quotas": "Create quotas",
   "?Créer de nouveaux quotas": "Create new quotas",
   "?Modèle Quotas": "Quotas Template",
   "?Ce modèle quota existe déjà": "This quota template already exists",
   "?Ce quota existe déjà": "This quota already exists for this customer at this period",
   "?confirmer_suppression_modele": "Do you really want to delete this template?",
   "?Ajouter": "Add",
   "?Remplacer l'existant": "Replace existing",
   "?Cumuler les quantités": "Cumulate quantities",
   "?Choisir le mode d'import": "Choose import mode",
   "?Import : SKU manquant, inconnu ou quantité invalide": "Import: missing or unknown SKU, or invalid quantity. Please check the file.",
   "?Fichier importé avec succès": "File imported successfully",
   "?Aucune ligne valide dans le fichier": "No valid lines in the file",
   "?Erreur lors de la lecture du fichier": "Error reading the file",
   "?Quota créé et lignes importées": "Quotas created and lines imported",
   "?À valider": "Pending approval",
   "?Soumises": "Submitted",
   "?Soumettre": "Submit",
   "?Remise globale": "Bulk discount",
   "?Sauvegarde locale": "Local backup",
   "?Restaurer une sauvegarde": "Restore a backup",
   "?Sauvegarde": "Saved",
   "?Fichier JSON invalide": "Invalid JSON file (missing id, customer_id or lines)",
   "?Commande restaurée": "Order restored",
   "?Commande %1 importée": "Order %1 imported",
   "?La commande courante sera écrasée par le contenu du fichier.": "The current order will be overwritten with the file content.",
   "?Une nouvelle commande %1 sera créée.": "A new order %1 will be created.",
   "?L'identifiant de la commande ne sera pas modifié.": "The order ID will not be changed.",
   "?Écraser": "Overwrite",
   "?Type incompatible : %1 ≠ %2": "Incompatible type: %1 ≠ %2",
   "?Client incompatible : %1 ≠ %2": "Incompatible customer: %1 ≠ %2",
   "?Créer depuis sauvegarde": "Create from backup",
   "?Commande %1 créée depuis sauvegarde": "Order %1 created from backup",
   "?Sélection de": "Selection of",
   "?Déployer vers clients": "Deploy to customers",
   "?Supprimer le déploiement": "Delete deployment",
   "?Déploiement en cours": "Deployment in progress",
   "?Suppression du déploiement en cours": "Deletion in progress",
   "?Les clients suivants ont des quotas pour la période %1.": "The following customers have quotas for period %1.",
   "?Les quotas des clients sélectionnés seront supprimés :": "Selected customers' quotas will be deleted:",
   "?Aucun client concerné pour cette période": "No customer affected for this period",
   "?Déployer": "Deploy",
   "?Sans quota": "Without quota",
   "?Avec quotas": "With quotas",
   "?sélectionné": "selected|selected",
   "?déjà avec quotas": "already with quotas",
   "?Chargement...": "Loading…",
   "?Aucun client éligible": "No eligible customer",
   "?ID": "ID",
   "?Quotas existants": "Existing quotas",
   "?Pour les clients ayant déjà des quotas :": "For customers with existing quotas:",
   "?Remplacer les quantités existantes": "Replace existing quantities",
   "?Ajouter les nouvelles lignes": "Add new lines",
   "?Supprimer les lignes absentes": "Remove missing lines",
   "?Aucune option : les quotas existants ne seront pas modifiés.": "No option selected: existing quotas will not be modified.",
   "?KTM vide : les quotas existants des clients sélectionnés pour cette période seront supprimés.": "Empty KTM: existing quotas of the selected customers for this period will be deleted.",
   "?Période invalide sur le KTM": "Invalid period on KTM",
   "?créé": "created|created",
   "?mis à jour": "updated",
   "?supprimé": "deleted|deleted",
   "?ignoré": "skipped|skipped",
   "?Déploiement terminé": "Deployment done",
   "?pwa_updating": "Updating the application…",
   "?pwa_new_version": "New version available",
   "?pwa_reload": "Reload",
   "?pwa_db_incompatible": "This version of the application is incompatible with the local data on this device. Please contact support.",
}

export default enTrans